export function init() {
  // Toggle Sign In and Recover password
  const linkRecoverPassword = document.querySelector(".link-recover-password");
  const linkSignIn = document.querySelector(".link-sign-in");
  const signInDiv = document.getElementById("sign-in");
  const recoverPasswordDiv = document.getElementById("recover");

  // Was reset form submitted?
  const divRoleStatus = document.querySelector("div[role=status]");
  if (divRoleStatus) {
    signInDiv.style.display = "none";
    recoverPasswordDiv.style.display = "block";
  }

  if (
    linkRecoverPassword instanceof HTMLElement &&
    recoverPasswordDiv instanceof HTMLElement &&
    signInDiv instanceof HTMLElement &&
    linkSignIn instanceof HTMLElement
  ) {
    linkRecoverPassword.addEventListener("click", (e) => {
      e.preventDefault();
      signInDiv.style.display = "none";
      recoverPasswordDiv.style.display = "block";
    });
    linkSignIn.addEventListener("click", (e) => {
      e.preventDefault();
      recoverPasswordDiv.style.display = "none";
      signInDiv.style.display = "block";
    });
  }

  // Make labels smaller on input
  let forms = Array.from(document.querySelectorAll("form:not([role=search])"));
  let allInputs = [];
  for (let form of forms) {
    let inputs = Array.from(form.querySelectorAll("label + input"));
    allInputs = allInputs.concat(inputs);
  }
  for (let input of allInputs) {
    /*  input.addEventListener("click", () => {
      input.previousElementSibling.classList.add("label-small");
    }); */
    input.addEventListener("focus", () => {
      input.previousElementSibling.classList.add("label-small");
    });   

    // fix form autofill it.
    var event = new Event('focus');      
    input.dispatchEvent(event);       
  }
 
}
